<template>
    <div>
        <div v-if="getPaymentMethods" class="show-cards">
            <p class="payment-title-top">Your cards</p>
            <div v-for="(card, index) in getPaymentMethods" :key="index">
                <div
                    class="card-wrapper"
                    :class="{ 'card-wrapper-selected': index === selectedCardIndex }"
                >
                    <div class="payment-method-container" @click="selectCard(index, card)">
                        <div class="select-card">
                            <img
                                v-if="index !== selectedCardIndex"
                                :src="getIcon() + 'unselect-card.png'"
                            />
                            <img
                                v-if="index === selectedCardIndex"
                                :src="getIcon() + 'select-card-point.png'"
                            />
                            <div class="d-flex flex-column">
                                <p class="card-info">
                                    <span style="color: #acacac"
                                        >{{ card.brand }} ending in </span
                                    >{{ card.last_four }}
                                </p>
                                <p class="card-info">
                                    <span style="color: #acacac">Expires</span>
                                    {{ card.exp_month }}/{{ card.exp_year }}
                                </p>
                            </div>
                        </div>
                        <div class="cart-image">
                            <img
                                :src="
                                    card.brand ? ccBrandIcons[card.brand] : ccBrandIcons.others
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>
            <button class="add-new-card" @click="showCardFields" v-if="!addNewCard">
                Add new card
            </button>
            <div class="mb-4">
                <p v-if="errorText" class="error-text">{{ errorText }}</p>
            </div>
        </div>
        <div v-if="!getPaymentMethods || addNewCard" class="payment-form d-flex flex-column">
            <p class="payment-title">Card details</p>
            <div v-if="width > 600" class="row-field">
                <div class="field-content" style="flex: 0 1 80%">
                    <p class="input-lable">Card holder *</p>
                    <input
                        type="text"
                        v-model="cardInfo.cardholderName"
                        @input="validationCardHolder()"
                        placeholder="Enter the card holder’s full name"
                        :class="{
                            'error-field': validateRules.cardholderName,
                            'input-border': !validateRules.cardholderName
                        }"
                        required
                    />
                </div>
                <div class="field-content" style="flex: 0 1 20%">
                    <p class="input-lable">Exp Date*</p>
                    <input
                        ref="cardExpDate"
                        type="text"
                        class="me-3"
                        v-mask="'##/##'"
                        v-model="cardInfo.expDate"
                        @input="validationExpDate()"
                        placeholder="MM/YY"
                        :class="{
                            'error-field': validateRules.expDate,
                            'input-border': !validateRules.expDate
                        }"
                        required
                    />
                </div>
            </div>
            <div v-if="width > 600" class="row-field">
                <div class="field-content" style="flex: 0 1 80%">
                    <p class="input-lable">Card number *</p>
                    <input
                        ref="cardNumber"
                        v-model="cardInfo.cardNumber"
                        @input="validationCardNumber()"
                        @keyup.delete="checkCard = false"
                        maxlength="25"
                        v-mask="'#### #### #### #### ###'"
                        type="text"
                        placeholder="Enter your card number"
                        :class="{
                            'error-field': validateRules.cardNumber,
                            'input-border': !validateRules.cardNumber
                        }"
                        required
                        data-testid="cardNumber-input"
                    />
                </div>
                <div class="field-content" style="flex: 0 1 20%">
                    <p class="input-lable">CVC *</p>
                    <input
                        ref="cvc"
                        v-model="cardInfo.cvc"
                        @input="validationCVC()"
                        type="number"
                        placeholder="***"
                        :class="{
                            'error-field': validateRules.cvc,
                            'input-border': !validateRules.cvc
                        }"
                        required
                        data-testid="cvc-input"
                    />
                </div>
            </div>
            <div v-if="width < 600" class="row-field flex-column">
                <div class="field-content w-100">
                    <p class="input-lable">Card holder *</p>
                    <input
                        type="text"
                        v-model="cardInfo.cardholderName"
                        @input="validationCardHolder()"
                        placeholder="Enter the card holder’s full name"
                        :class="{
                            'error-field': validateRules.cardholderName,
                            'input-border': !validateRules.cardholderName
                        }"
                        required
                    />
                </div>
                <div class="field-content w-100">
                    <p class="input-lable">Card number *</p>
                    <input
                        ref="cardNumber"
                        v-model="cardInfo.cardNumber"
                        @keyup.delete="checkCard = false"
                        @input="validationCardNumber()"
                        @blur="getLastFour()"
                        type="text"
                        placeholder="Card number *"
                        :class="{
                            'error-field': validateRules.cardNumber,
                            'input-border': !validateRules.cardNumber
                        }"
                        required
                        data-testid="cardNumber-input"
                    />
                </div>
            </div>
            <div v-if="width < 600" class="row-field">
                <div class="field-content">
                    <p class="input-lable">Exp Date*</p>
                    <input
                        ref="cardExpDate"
                        type="text"
                        class="me-3"
                        v-mask="'##/##'"
                        v-model="cardInfo.expDate"
                        @input="validationExpDate()"
                        placeholder="Exp Date *"
                        :class="{
                            'error-field': validateRules.expDate,
                            'input-border': !validateRules.expDate
                        }"
                        required
                    />
                </div>
                <div class="field-content">
                    <p class="input-lable">CVC *</p>
                    <input
                        ref="cvc"
                        v-model="cardInfo.cvc"
                        @input="validationCVC()"
                        type="number"
                        placeholder="CVC *"
                        :class="{
                            'error-field': validateRules.cvc,
                            'input-border': !validateRules.cvc
                        }"
                        required
                        data-testid="cvc-input"
                    />
                </div>
            </div>
            <p v-if="this.checkCard" class="error-exist">This card is already exist</p>
        </div>
        <div v-if="!getPaymentMethods || addNewCard" class="btn-block">
            <p class="cancel-bnt" @click="canselBtn">Cancel</p>
            <button
                @click="addPaymentMethod()"
                :disabled="!allFiledsCompeted"
                :class="{ disabled: !allFiledsCompeted }"
            >
                Save Card
            </button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../helpers/notification'
    import checkScreen from '../../mixins/check-screen'
    import { creditCardsValidation } from '../../mixins/credit-card-validation'
    export default {
        name: 'PaymentFields',
        mixins: [checkScreen, creditCardsValidation],
        props: {
            paymentMethods: {
                type: Array
            },
            cardStripeId: {
                type: String
            }
        },
        emits: ['addNewCard', 'update:payment-methods', 'update:card-stripe-id'],
        data: () => ({
            cardNumber: '',
            cardExpDate: '',
            cvc: '',
            paymentMethods: [],
            selectedCardIndex: null,
            addNewCard: false,
            ccBrandIcons: {
                'American Express': '/images/icons/payment-details/cc-amex.svg',
                Visa: '/images/icons/payment-details/cc-visa.svg',
                MasterCard: '/images/icons/payment-details/cc-mastercard.svg',
                Discover: '/images/icons/payment-details/cc-discover.svg',
                UnionPay: '/images/icons/payment-details/UnionPay.svg',
                DinaCard: '/images/icons/payment-details/DinaCard.svg',
                'Diners Club': '/images/icons/payment-details/DinersClub.svg',
                BCCard: '/images/icons/payment-details/BCCard.svg',
                JCB: '/images/icons/payment-details/JSB.svg',
                others: '/images/icons/payment-details/cc-regular.svg'
            }
        }),
        methods: {
            disableBtn() {
                this.$emit('addNewCard', this.addNewCard)
            },
            validationExistCard(payments) {
                const lastFour = this.cardInfo.cardNumber.slice(-4)
                if (payments.length) {
                    this.checkCard = payments.some((card) => card.last_four === lastFour)
                    return this.checkCard
                }
            },
            canselBtn() {
                this.addNewCard = !this.addNewCard
                for (const key of Object.keys(this.cardInfo)) {
                    this.cardInfo[key] = ''
                }
                this.disableBtn()
            },
            getFirstCard() {
                if (this.paymentMethods.length) {
                    const lastCardIndex = this.paymentMethods.length - 1
                    const lastCard = this.paymentMethods[lastCardIndex]
                    this.selectCard(lastCardIndex, lastCard)
                }
            },
            selectCard(index, card) {
                this.selectedCardIndex = index
                this.$emit('update:card-stripe-id', card.card_stripe_id)
            },
            fetchPaymentMethods() {
                axios
                    .get('/profile/stripe/get-payment-methods')
                    .then((response) => {
                        this.$emit('update:payment-methods', response.data.data)
                        this.getFirstCard()
                    })
                    .catch((error) => {
                        notification('error', error)
                    })
            },
            getIcon() {
                return '/images/'
            },
            showCardFields() {
                this.addNewCard = true
                this.disableBtn()
            },
            async addPaymentMethod() {
                if (
                    this.validationPass(this.validateRules) &&
                    !this.validationExistCard(this.paymentMethods)
                ) {
                    try {
                        let cardNumber = this.prepareCardNumber(this.cardInfo.cardNumber)
                        const name = this.cardInfo.cardholderName.split(' ')
                        const firstName = name[0]
                        const lastName = name[1]
                        const response = await axios.post(
                            '/profile/event-add-payment-method',
                            {
                                first_name: firstName,
                                last_name: lastName,
                                card_number: cardNumber,
                                exp_date: this.cardInfo.expDate,
                                cvc: this.cardInfo.cvc
                            }
                        )
                        let exp_month = this.cardInfo.expDate.split('/')[0]
                        let exp_year = ` 20${this.cardInfo.expDate.split('/')[1]}`
                        let cardData = {
                            cardholderName: response.data.data.cardholder_name,
                            last_four: response.data.data.last_four,
                            exp_year: exp_year,
                            exp_month: exp_month,
                            card_stripe_id: response.data.data.card
                        }
                        this.paymentMethods.push(cardData)
                        this.addNewCard = false
                        this.cardInfo.cardNumber = ''
                        this.cardInfo.expDate = ''
                        this.cardInfo.cvc = ''
                        this.cardInfo.cardholderName = ''
                        this.getFirstCard()
                        this.disableBtn()
                        notification('success', response.data.message)
                        this.addNewCard = false
                        this.disableBtn()
                    } catch (error) {
                        notification('error', error)
                    }
                }
            }
        },
        computed: {
            allFiledsCompeted() {
                return (
                    this.validationPass(this.validateRules) &&
                    this.cardInfo.cardholderName.length &&
                    this.cardInfo.cardNumber.length &&
                    this.cardInfo.cvc &&
                    this.cardInfo.expDate.length
                )
            },
            getPaymentMethods() {
                return this.paymentMethods
            }
        },
        async created() {
            await this.fetchPaymentMethods()
        },
        beforeDestroy() {
            localStorage.removeItem('eventStart')
            localStorage.removeItem('eventLocation')
            localStorage.removeItem('eventDuration')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .disabled {
        opacity: 0.6;
    }
    .btn-block-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }
    .btn-block-footer button {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        width: 100%;
    }
    .row-field {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .field-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .input-lable {
        color: #8b8b8b;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .show-cards {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .select-card {
        display: flex;
        align-items: center;
        gap: 16px;
    }
    .card-wrapper {
        display: flex;
        padding: 16px;
        align-items: center;
        gap: 20px;
        border-radius: 15px;
        border: 1px solid #8b8b8b;
    }
    .card-wrapper-selected {
        border: 1px solid #cdeb09;
    }
    .payment-method-container {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .btn-block {
        display: flex;
        align-items: baseline;
        gap: 24px;
        justify-content: center;
    }
    .btn-block button {
        padding: 7px 30px 9px 30px;
        border-radius: 100px;
        background: #cdeb09;
        border: 0;
        color: #161616;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }
    .cancel-bnt {
        color: #8b8b8b;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss09' on, 'ss08' on, 'ss03' on, 'ss07' on, 'ss02' on;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
    }
    .card-info {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.01em;
        font-feature-settings: 'calt' off;
        color: #ffffff;
        margin-bottom: 0;
    }
    .add-new-card {
        display: flex;
        padding: 12px 16px;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        cursor: pointer;
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .add-new-card img {
        width: 22px;
        height: 22px;
    }
    .error-text {
        color: #f54040;
        text-align: center;
        font-size: 15px;
    }
    .form-check-input {
        min-width: 25px;
        border-radius: 15px;
        margin-left: 15px;
    }
    .cart-image {
        margin-right: 20px;
    }
    .input-border {
        border: 1px solid #ffffff63;
    }
    .error-field {
        border: 1px solid #ca2121;
    }
    .error-exist {
        color: #ca2121;
    }
    .payment-form input {
        border-radius: 12px;
        padding: 12px 16px 16px 16px;
        background-color: #ffffff00;
        margin-bottom: 15px;
        color: #ffffff;
        width: 100%;
    }
    input::placeholder {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .payment-title-top {
        color: #acacac;
        text-align: start;
        font-family: 'Instrument Sans';
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .payment-title {
        color: #dedede;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
</style>
